<template>
  <div class="sidebar">

    <div id="desktopMenu">
    <ul class="sidebar--top">
      <li>
        <router-link to="/dashboard" :class="{disabled : disabled}">
          <i class="icon-dashboard"></i>
          <span class="nav-title">Dashboard</span>
        </router-link>
      </li>
      <li>
        <router-link to="/kits" :class="{disabled : disabled}">
          <i class="fas fa-hdd"></i>
          <span v-if="getAppType === 'CUSTOMER'" class="nav-title">My Kits</span>
          <span v-if="getAppType === 'RESEARCH'" class="nav-title">My Research</span>
        </router-link>
      </li>
      <li v-if="enableSurveys && getAppType === 'CUSTOMER'">
        <router-link to="/surveys" :class="{disabled : disabled}">
          <i class="icon-clipboard"></i>
          <span class="nav-title">Questionnaires</span>
        </router-link>
      </li>
      <li v-if="getAppType === 'CUSTOMER'">
        <router-link :to="{ name: 'Reports'}" :class="{disabled : disabled}">
          <i class="icon-pie-chart"></i>
          <span class="nav-title">Reports</span>
        </router-link>
      </li>
      <li v-if="getAppType === 'CUSTOMER'">
        <router-link to="/coach" :class="{disabled : disabled}">
          <i class="icon-coach"></i>
          <span class="nav-title">Coach</span>
        </router-link>
      </li>
    </ul>
    <ul class="sidebar--bottom" :class="className">
      <li class="more">
        <a v-on:click="toggleMore">
          <i class="icon-ellipses"></i>
          <span class="nav-title">More</span>
        </a>
        <ul>
          <li>
            <router-link to="/profile">
              <i class="icon-person"></i>
              <span class="nav-title">My Profile</span>
            </router-link>
          </li>
          <li>
            <router-link to="/support" clsss="nav-link">
              <i class="icon-support"></i>
              <span class="nav-title">Support</span>
            </router-link>
          </li>
          <li>
            <a v-on:click="logout" clsss="nav-link">
              <i class="icon-account-logout"></i>
              <span class="nav-title">Log Out</span>
            </a>
          </li>
          <li class="text-center pt-2">
            <small>{{ getVersion }}</small>
          </li>
        </ul>
      </li>
    </ul>
    </div>

    <ul id="mobileMenu" @click.prevent="toggleMobileMenu">
      <li class="w-100">
        <span class="menuBtn">
          <i class="fas fa-times" v-if="showMenu"></i>
          <i class="fas fa-bars" v-else></i>
          <span href="#">Menu</span>
        </span>
      </li>
    </ul>

    <div id="mobileMenuBody" v-if="showMenu">

      <ul class="list-group list-group-flush">
        <li class="list-group-item"  @click.prevent="openPage('dashboard')">
          <i class="icon-dashboard"></i>
          <span>Dashboard</span>
        </li>
        <li class="list-group-item" @click.prevent="openPage('kits')">
            <i class="fas fa-hdd"></i>
          <span v-if="getAppType === 'CUSTOMER'" class="nav-title">My Kits</span>
          <span v-if="getAppType === 'RESEARCH'" class="nav-title">My Research</span>
        </li>
        <li v-if="getAppType === 'CUSTOMER'" class="list-group-item" @click.prevent="openPage('surveys')">
          <i class="icon-clipboard"></i>
          <span>Questionnaires</span>
        </li>
        <li v-if="getAppType === 'CUSTOMER'" class="list-group-item" @click.prevent="openPage('Reports')">
          <i class="icon-pie-chart"></i>
          <span>Reports</span>
        </li>
        <li v-if="getAppType === 'CUSTOMER'" class="list-group-item" @click.prevent="openPage('coach')">
          <i class="icon-coach"></i>
          <span>Microbiome Coach</span>
        </li>
        <li class="list-group-item" @click.prevent="openPage('profile')">
          <i class="icon-person"></i>
          <span>My Profile</span>
        </li>
        <li class="list-group-item" @click.prevent="openPage('support')">
          <i class="icon-support"></i>
          <span>Support</span>
        </li>
        <li class="list-group-item logout" @click.prevent="logout">
          <i class="icon-account-logout"></i>
          <span>Logout</span>
        </li>
      </ul>

    </div>

  </div>
</template>
<script>
import SidebarNavDropdown from '@/components/elements/SidebarNavDropdown'
import SidebarNavLink from '@/components/elements/SidebarNavLink'
import SidebarNavTitle from '@/components/elements/SidebarNavTitle'
export default {
  name: 'sidebar',
  components: {
    SidebarNavDropdown,
    SidebarNavLink,
    SidebarNavTitle
  },
  data: function () {
    return {
      showDropdown: false,
      disabled: false,
      showMenu: false
    }
  },
  computed: {
    className: function () {
      return (this.showDropdown) ? 'menu-open' : 'menu-close'
    },
    enableSurveys: function () {
      // return true
      return process.env.ENABLE_SURVEYS === 'true' || false // .env by default are strings
    },
    getAppType () {
      return process.env.APP_TYPE
    },
    getVersion () {
      if (process.env.APP_TYPE === 'CUSTOMER') {
        return 'C.' + process.env.APP_VERSION_CUSTOMER
      } else if (process.env.APP_TYPE === 'RESEARCH') {
        return 'R.' + process.env.APP_VERSION_RESEARCH
      }
      return 'U.0.0.0'
    }
  },
  methods: {
    openPage (page) {
      this.showMenu = false
      this.$router.push(page)
    },
    toggleMobileMenu () {
      this.showMenu = !this.showMenu
    },
    handleClick (e) {
      e.preventDefault()
      e.target.parentElement.classList.toggle('menu-open')
    },
    logout: function () {
      this.$store.dispatch('logout').then(() => {
        this.$router.push('/login')
      })
    },
    toggleMore: function () {
      this.showDropdown = !this.showDropdown
    },
    closeMore: function () {
      this.showDropdown = false
    }
  },
  created () {
    window.addEventListener('scroll', this.closeMore)
    this.$bus.$on('enableSidebar', (profile) => {
      this.disabled = false
    })
    this.$bus.$on('disableSidebar', (profile) => {
      this.disabled = true
    })
  }
}
</script>

<style scoped lang="scss">
  @media (min-width: 576px) {
    #desktopMenu {
      display:block;
      li {
        a {
          text-transform: none;
        }
      }
    }
    #mobileMenu{
      display:none;
    }
    #mobileMenuBody{
      display:none;
    }
  }
  @media (max-width: 760px) {
    #desktopMenu {
      display:none;
    }
    #mobileMenu{
      display:block;
      color: #ff8708;
      width:100%;

      .menuBtn {
        margin-left: 10px;
        margin-top: 10px;
        margin-bottom: 7px;
        cursor: pointer;
      }

      li {
        width:100% !important;
      }
      i {
        color: #ff8708;
        display:inline-block;
        font-size:28px !important;
        padding-top:0px;
      }
      span {
        display:inline-block;
        font-size:28px !important;
      }
    }
    #mobileMenuBody {
      display: block;
      ul {
        display: flex;
        align-items: stretch; /* Default */
        justify-content: space-between;
        flex-direction: column;
        font-size: 18px;
        padding: 20px 10px;
        width:100%;
        height:100%;
        background: none;

        li {
          display: block;
          flex: 0 1 auto; /* Default */
          list-style-type: none;
          padding-left: 10px;
          background: none;
          border:none;
        }
        .logout{
          color: #589ecb;
           i {
             color: #589ecb;
           }
        }
        .list-group-item {
          display: flex;

          span {
            padding-left: 10px;
          }
          i {
            width:60px;
            padding: 0px;
            padding-top: 6px;
          }
        }
      }
    }

  }


  #mobileMenuBody{
    position: fixed;
    top: 0;
    left: 0;
    width:100%;
    height:calc(100% - 59px);
    background: #e5e7ea ;
  }

.disabled {
  opacity: 0.4;
  pointer-events: none;
}
  .imgIcon{
    display: block;
    margin: 20px auto 10px auto;
  }

  .mobileMenu{

  }

  .menuBtn{
    font-size:20px;
    margin-top:40px;
    margin-bottom:40px;
  }
</style>



// WEBPACK FOOTER //
// src/components/parts/Sidebar.vue